import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["select"]

  initialize() {
    this.selectCmsFields($("#task_content_management_system_id").val());
  }

  selectCmsFields(selected_cms_id) {
    $("[data-field-cms-id]").each(function() {
      let cms_id = $(this).data("field-cms-id");
      if (cms_id == selected_cms_id) {
        $(this).find('input, button, select, textarea').attr('disabled', false);
        $(this).show();
      } else {
        $(this).find('input, button, select, textarea').attr('disabled', true);
        $(this).hide();
      }
    });
  }

  updateDependents(e) {
    this.selectCmsFields($(e.target).find(":selected").val());
  }
}